import { Role } from "@/modules/roles/composables/useRoles";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useRolesStore = defineStore("roles", () => {
  const roles = ref<Role[]>([]);
  const companyId = ref<number>();

  return {
    roles,
    companyId,

    setRoles(value: Role[]) {
      roles.value = value;
    },

    setCompanyId(value: number) {
      companyId.value = value;
    },

    resetState() {
      roles.value = [];
      companyId.value = undefined;
    },
  };
});
